import { defineComponent as _defineComponent } from 'vue'
import { onMounted, computed } from 'vue';
import { useDonationFormsStore } from '../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductDonationInfo',
  props: {
  product_total: {
    type: Number,
    required: true
  },
  symbol: {
    type: String,
    required: true
  },
  symbols: {
    type: Object,
    default: () => ({})
  },
  quantity: {
    type: Object,
    required: true
  },
  strings: {
    type: Object,
    default: () => ({})
  }
},
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();

const props = __props;

const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const getSymbol = () => {
  return props.symbols[store.currency] != undefined ? props.symbols[store.currency] : props.symbol;
};

const convert = (amt: number) => {
  const { exchange_rates } = lifeline_donation;
  const syb = store.currency;
  if (_.get(exchange_rates, syb)) {
    return (_.get(exchange_rates, syb) * amt).toFixed(2);
  }
  return amt.toFixed(2);
};

const getConvertedTotal = () => {
  return convert(props.product_total);
};

const getItemPrice = () => {
  // Calculate item price by dividing total by total quantity
  const totalQuantity = Object.values(props.quantity).reduce((sum: number, qty: any) => sum + parseInt(qty), 0);
  const itemPrice = totalQuantity > 0 ? (props.product_total / totalQuantity) : props.product_total;
  return convert(itemPrice);
};

const getQuantityText = () => {
  const items = Object.entries(props.quantity).map(([id, qty]) => `${qty} item(s)`);
  return items.join(', ');
};

onMounted(() => {
  console.log('ProductDonationInfo mounted with props:', props);
  console.log('product_total:', props.product_total);
  console.log('quantity:', props.quantity);
});

const __returned__ = { store, props, lifeline_donation, _, getSymbol, convert, getConvertedTotal, getItemPrice, getQuantityText }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})